<template>
  <div class="__C_SearchBox">
    <q-input
      ref="input"
      v-model="currentValue"
      :placeholder="placeholder"
      outlined
      dense
      :disable="disabled"
      style="width:100%"
    >
      <template v-slot:prepend>
        <CIcon name="search" material />
      </template>

      <template v-if="currentValue" v-slot:append>
        <q-icon name="cancel" @click.stop="currentValue = ''" class="cursor-pointer" />
      </template>
    </q-input>
  </div>
</template>

<script>
import CIcon from '@/components/uikit/CIcon';

const messages = {
  en: {
    Search: 'Search',
  },
  ja: {
    Search: '検索する',
  },
};

export default {
  name: 'CSearchBox',
  i18n: { messages },
  components: { CIcon },
  props: {
    value: { type: [String, Number] },
    placeholder: { type: String },
    disabled: { type: Boolean },
  },
  computed: {
    currentValue: {
      set(val) {
        this.$emit('input', val);
      },
      get() {
        return this.value;
      },
    },
  },
};
</script>

<style lang="scss" scoped>
.__C_SearchBox {
  width: 100%;
}
</style>
